import { render, staticRenderFns } from "./DOrganizePreview.vue?vue&type=template&id=6b7f733d&scoped=true&"
import script from "./DOrganizePreview.vue?vue&type=script&lang=js&"
export * from "./DOrganizePreview.vue?vue&type=script&lang=js&"
import style0 from "./DOrganizePreview.vue?vue&type=style&index=0&id=6b7f733d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7f733d",
  null
  
)

export default component.exports